export class Servico {
    public id: Number;
    public serviceName: String;
    public serviceDescription: String;
    public now: Number;
    public startOfService: Number;
    public endOfService: Number;
    public workflowId: Number;
    public canCancel: Boolean;
    public requireLocation: Boolean;
    public cancelLimit: Number;
    public requireInstitution: Boolean;
    public singleRegistration: Boolean;
    public requireBusLineSelection: boolean;
    public requireInstitutionAdditionalData: boolean;
    public requireUserAdditionalData: Boolean;
    public invited: boolean;
    public mustBeInvited: boolean;
    public notInvitedError: String;
    public appointment: Boolean;
    public issueCard: Boolean;
    public mustAcceptTerms: Boolean;
    public terms: String;
    public termsConfirmation: String;
    public requiredDocs: RequiredDocs[];
    public information: String;
    public allowEdit: Boolean;
    public serviceTypeList: ServiceTypeList[];
    public editableInstitutionName: Boolean;
    public requireAddress: Boolean;
    public requireCardNumber: Boolean;
    public requireCustomerDescription: Boolean;
    public hasPayment: Boolean;
    public hasShipping: Boolean;
    public valueToPay: number;
    public valueToPayFormatted: String;
    public shippingFee: number;
    public totalValue: number;
    public totalValueFormatted: String;
    public requireNationality: Boolean;
    public requireMaritalStatus: Boolean;
    public requireMobileNumber: Boolean;
    public requireResponsavel: Boolean;
    public requireEmployeeList: boolean;
    public serviceTypeId: number;
}

export class RequiredDocs {
    public id: Number;
    public name: String;
    public description: String;
    public code: String;
    public required: Boolean;
}

export class ServiceTypeList {
    public id: Number;
    public description: String;
    public active: Boolean;
}

